import React from 'react';
import { keyframes } from '@emotion/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useTranslation from '../../customHooks/translations';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const slide = keyframes`
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(400%); }
`;

const fadeInDown = keyframes`
  from { opacity: 0; transform: translate(-50%, -12px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
`;

const SmallTopLoader = () => {
  const translation = useTranslation();

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        animation: `${fadeInDown} 0.25s ease both`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        pointerEvents: 'none',
      }}
    >
      {/* Pill chip */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          px: 2,
          py: 0.75,
          borderRadius: 99,
          background: 'rgba(13,27,42,0.88)',
          backdropFilter: 'blur(10px)',
          border: `1px solid ${DEFAULT_THEME_COLOR}44`,
          boxShadow: `0 4px 20px rgba(0,0,0,0.35), 0 0 0 1px ${DEFAULT_THEME_COLOR}22`,
          overflow: 'hidden',
          minWidth: 160,
        }}
      >
        {/* Animated shimmer bar */}
        <Box sx={{ position: 'relative', width: 28, height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.1)', overflow: 'hidden', flexShrink: 0 }}>
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              width: '25%',
              borderRadius: 2,
              background: `linear-gradient(90deg, transparent, ${DEFAULT_THEME_COLOR}, transparent)`,
              animation: `${slide} 1.1s ease-in-out infinite`,
            }}
          />
        </Box>

        <Typography
          sx={{
            color: 'rgba(255,255,255,0.75)',
            fontSize: '0.78rem',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            letterSpacing: '0.01em',
          }}
        >
          {translation.freakPlaces.loadingFreakPlaces}
        </Typography>
      </Box>
    </Box>
  );
};

export default SmallTopLoader;
